/* eslint-disable react/no-array-index-key */

import React, {Component} from 'react';
import PropTypes from 'prop-types';


class SingleChoice extends Component {

    static canContinue(answer) {
        const {choices = []} = answer;
        return !Boolean(typeof choices[0] === 'number');
    }

    render() {
        const {config: {choices = []}, answer: {choices: answerChoices = []}, id, disabled} = this.props;
        const checked = answerChoices.length > 0 ? answerChoices[0] : -1;

        return (
            <ul className="single-choice-list">
                {choices.map(({choice}, index) => (
                    <li key={index} className="single-choice">
                        <input
                            id={`single-choice-${id}-${index}`}
                            type="radio"
                            name={`answer-${id}`}
                            value={index}
                            onChange={this.onChange}
                            checked={index === checked}
                            disabled={disabled}
                        />
                        <label htmlFor={`single-choice-${id}-${index}`}>{choice}</label>
                    </li>
                ))}
            </ul>
        );
    }

    onChange = event => {
        const target = event.currentTarget;
        const choices = [+target.value];

        return this.props.updateAnswer({choices});
    };
}

SingleChoice.propTypes = {
    config: PropTypes.shape({
        choices: PropTypes.array.isRequired,
    }).isRequired,
    answer: PropTypes.shape({
        choice: PropTypes.number,
    }).isRequired,
    disabled: PropTypes.bool,
    updateAnswer: PropTypes.func.isRequired,
    id: PropTypes.number,
};

SingleChoice.defaultProps = {
    disabled: false,
    id: 0,
};

export default SingleChoice;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/SingleChoice.js